import React from 'react';

const MessagesList = (props) => {
    const {messages} = props;
    const renderMessage = (message) => {
        switch(message.type){
            case 'info':
                return "اطلاعیه : " + message.message;
            case 'warning':
                return "هشدار : " + message.message;
            case 'danger':
                return "اخطار : " + message.message;
            default:
                return '';
        }
    };
    return (
        <div className="messages-list-holder">
            {
                messages.map((message,index) => {
                    return (
                        <div className={"message-item " + message.type } key={index}>
                            {renderMessage(message)}
                        </div>
                    )
                })
            }
        </div>
    )
};

export default MessagesList;